import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId:
            //"df832774-47c3-4b97-a0b6-4cef8594d304", // DEV
            //"78073266-ebb0-4c12-b9d1-ba0917090aff", // UAT
            "65a65bb4-def1-4814-8fad-c9bd1e67e507", // PROD
        authority:
            //"https://login.microsoftonline.com/564c5c34-4281-4122-aaa1-aafcb04b99fa", // DEV
            "https://login.microsoftonline.com/d6fc3a4e-56de-470f-b31f-585de92433c0", // UAT/PROD
        redirectUri: "/portfolio",
        postLogoutRedirectUri: "/",
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
        },
        allowNativeBroker: false,
    },
};

export const loginRequest = {
    scopes: [],
};
